import type { ReactNode } from 'react'
import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom'
import { AppShell } from './components/AppShell'
import BoothScanner from './pages/BoothScanner'
import AdminConsole from './pages/AdminConsole'
import McConsole from './pages/McConsole'
import Screen from './pages/Screen'
import JudgeConsole from './pages/JudgeConsole'
import Login from './pages/Login'
import StaffLogin from './pages/StaffLogin'
import PdpaNotice from './pages/PdpaNotice'
import Pass from './pages/Pass'
import Register from './pages/Register'
import SystemCheck from './pages/SystemCheck'
import VerifyCertificate from './pages/VerifyCertificate'
import VerifyOtp from './pages/VerifyOtp'
import { getSession } from './lib/session'


function Shell({ width }: { width?: 'form' | 'wide' }) {
  return (
    <AppShell width={width}>
      <Outlet />
    </AppShell>
  )
}

function GuestOnly({ children }: { children: ReactNode }) {
  const location = useLocation()
  const session = getSession()

  if (session) return <Navigate to="/pass" replace state={{ from: location.pathname }} />
  return <>{children}</>
}

export default function App() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <GuestOnly>
            <Register />
          </GuestOnly>
        }
      />
      <Route
        path="/login"
        element={
          <GuestOnly>
            <Login />
          </GuestOnly>
        }
      />

      <Route
        path="/verify"
        element={
          <GuestOnly>
            <VerifyOtp />
          </GuestOnly>
        }
      />

      <Route path="/pass" element={<Pass />} />
      <Route path="/staff/login" element={<StaffLogin />} />


      <Route element={<Shell />}>
        <Route path="/verify/:token" element={<VerifyCertificate />} />

        {/*
          The PDPA notice, public and outside every guard: a student must be
          able to read it before handing over any details (slide 30).
        */}
        <Route path="/pdpa" element={<PdpaNotice />} />
        <Route path="/booth" element={<BoothScanner />} />
      </Route>

      <Route path="/judge" element={<JudgeConsole />} />
      <Route path="/judge/sheet/:id" element={<JudgeConsole />} />
      {/* The compère's read-only view, a beat ahead of the projector. */}
      <Route path="/mc" element={<McConsole />} />
      <Route path="/admin" element={<AdminConsole />} />
      <Route path="/screen" element={<Screen />} />

      <Route element={<Shell width="wide" />}>
        <Route path="/system" element={<SystemCheck />} />
      </Route>

      {/* Redirects for old paths */}
      <Route path="/booth/login" element={<Navigate to="/staff/login" replace />} />
      <Route path="/judge/login" element={<Navigate to="/staff/login" replace />} />
      <Route path="/admin/login" element={<Navigate to="/staff/login" replace />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
